import { useMemo } from 'react';
import { useCategories, useWidgetGamesCategory } from '../../store/selectors';
import { getFirstNPictureGames } from '../../utils';
import { useCasinoSettings } from '../useCasinoSettings';

export const usePrepareCollectionsCategories = (
  casinoType,
  gamesAmountInCollectionCard = 3
) => {
  const { collectionFeed: feedName } = useCasinoSettings(casinoType);
  const categories = useCategories(feedName);
  const preparedCategories = useWidgetGamesCategory(categories);
  return useMemo(
    () =>
      getFirstNPictureGames(
        preparedCategories,
        categories,
        gamesAmountInCollectionCard
      ),
    [categories, preparedCategories, gamesAmountInCollectionCard]
  );
};
